import { combineReducers } from "redux";

import list from "./List/reducer";
import view from "./View/reducer";

const formBsActivityReducer = combineReducers({
  list,
  view,
});

export default formBsActivityReducer;
